import { Grid, Typography } from '@material-ui/core'
import { FC } from 'react'
import { ResponseT } from '../../../services/um/useExternalResearcher'
import Item from './Item'

import useTranslate from '../../../i18n/useTranslate'
import useLoadingStore from '../../../control/loading/store/useLoadingStore'

interface ResultProps {
    onClickEdit: (userID: string) => void
    data: ResponseT[]
}
const Result: FC<ResultProps> = ({ onClickEdit, data }) => {
    const translate = useTranslate()
    const loadingStore = useLoadingStore()

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography variant="h6">{translate.get('LABEL.SEARCH_TOTAL_RESULT', [`${data.length}`])}</Typography>
            </Grid>
            <Grid item xs={12}>
                {data.map((item) => {
                    return (
                        <Grid item xs={12} key={item.userID}>
                            <Item data={item} onClickEdit={onClickEdit} />
                        </Grid>
                    )
                })}
            </Grid>

            {!loadingStore.isLoading && data?.length === 0 && (
                <Grid
                    container
                    item
                    alignContent="center"
                    justify="center"
                    style={{ border: '1px solid rgba(0, 0, 0, .125)' }}
                >
                    <Typography variant="h6">{translate.get('LABEL.NO_DATA_FOUND')}</Typography>
                </Grid>
            )}
        </Grid>
    )
}

export default Result
